<div id="driver-wizard"
     class="row ">
     <div class="d-flex justify-content-between align-items-center card-title"
          id="page-title">
          <h1 *ngIf="!service.justSubscribe"
              [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>

          <h1 *ngIf="service.justSubscribe"
              [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="8"
                                      [totalSteps]="11"></app-complete-bar>
                    <div class="overlay"
                         *ngIf="loadingQuiz">
                         <h1 class="heading"
                             [innerHtml]="'Loading' | translator: 'base'">
                              Loading...
                         </h1>
                         <img />
                    </div>
                    <div class="overlay"
                         *ngIf="isSaving">
                         <h1 class="heading"
                             [innerHtml]="'Loading' | translator: 'base'">
                              Loading...
                         </h1>
                         <img />
                    </div>
                    <h2 [innerHtml]="'IdVerify' | translator: 'base'">ID VERIFICATION</h2>
                    <div *ngIf="loadingQuiz === false">

                         <p class="step-text"
                            [innerHtml]="'IdVerifyInfoHelp' | translator: 'base'">
                              To provide you with the highest level of security, we would like to verify your identity
                              before
                              proceeding.
                         </p>
                         <p class="step-text"
                            [innerHtml]="'PleaseAnswer' | translator: 'base'">
                              Please answer the following questions to verify your identity.
                         </p>
                         <fieldset *ngFor="let q of idQuiz.questions; let qidx = index"
                                   class="mb-3">
                              <legend class="form-label"
                                      [attr.for]="q.questionId + ''">
                                   <span>{{q.text.statement}}</span>
                                   <span class="text-danger text-center ms-1"
                                         [title]="'Required' | translator: 'base'">*</span>
                                   <button *ngIf="q.helpText && q.helpText !== null && q.helpText.statement"
                                           type="button"
                                           class="btn btn-link btn-tooltip bg-white border-0 p-0 ms-1"
                                           placement="top"
                                           ngbTooltip="{{q.helpText.statement}}"
                                           data-bs-html="true">
                                        <i class="fas fa-circle-info"
                                           aria-hidden="true"></i>
                                        <span class="visually-hidden">Question tooltip</span>
                                   </button>
                                   <span *ngIf="q.helpText && q.helpText !== null && q.helpText.statement"
                                         class="sr-only">
                                        {{q.helpText.statement}}
                                   </span>
                              </legend>

                              <div *ngFor="let qc of q.choices; let qcidx = index"
                                   class="form-check">
                                   <label class="notBold">
                                        <input type="radio"
                                               class="form-check-input"
                                               [id]="qc.choiceId"
                                               [name]="q.questionId.toString()"
                                               [value]="qc.choiceId"
                                               (change)="selectionChanged(q.questionId, qc.choiceId)"
                                               required />
                                        {{qc.text.statement}}
                                   </label>
                              </div>
                         </fieldset>

                         <!-- --------------------------------------------------------------------------------- -->

                         <div class="row">
                              <div class="d-flex flex-row-reverse justify-content-between mt-2">
                                   <div class="btn-group" role="group">
                                        <button (click)="gradeQuiz()"
                                                class="btn btn-primary btn-strong"
                                                [title]="'Continue' | translator: 'base'"
                                                [innerHtml]="'Continue' | translator: 'base'"
                                                [disabled]="hasErrors"
                                                name="driverNext"
                                                id="driverNext">
                                             Continue
                                        </button>
                                   </div>

                                   <div class="btn-group"
                                        role="group">
                                        <button [routerLink]="service.backLinkRoute(9)"
                                                (click)="scrollToTop()"
                                                class="btn btn-outline-primary"
                                                [title]="'Back' | translator: 'base'"
                                                [innerHtml]="'Back' | translator: 'base'"
                                                name="driverBack"
                                                id="driverBack">
                                             Back
                                        </button>
                                        <button [routerLink]="service.cancelLinkRoute()"
                                                tag="button"
                                                class="btn btn-light"
                                                (click)="scrollToTop()"
                                                name="driverCancel"
                                                id="driverCancel"
                                                [innerHtml]="'Cancel' | translator: 'base'"
                                                [title]="'Cancel' | translator: 'base'">
                                             Cancel
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="4"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>

<style>
     .hide {
          display: none !important;
     }
</style>